import "./dashboard-sections.css";
import DashboardCard from "./DashboardCard";
import { Sun, Moon } from "lucide-react";
import { makePriorLotNumber } from "../../../helpers/Utils";
import { useGetPackingAnalyticsQuery } from "../dashBoardApi";

const MetricBox = ({ label, value, unit, theme = "orange" }) => (
  <div className={`pko-box pko-box-${theme}`}>
    <div className="pko-box-label">{label}</div>
    <div className="pko-box-value">{value ?? "—"}</div>
    {unit && <div className={`pko-box-unit pko-unit-${theme}`}>{unit}</div>}
  </div>
);

const BatchBadge = ({ startDate, endDate }) => (
  <span className="pko-batch-badge">
    #{makePriorLotNumber(startDate)} - #{makePriorLotNumber(endDate)}
  </span>
);

const PackingOverview = ({  data = [] ,startDate, endDate }) => {
  
  const {
    data : packingData ,
    isLoading : isPckDataLoading ,
    isFetching : isPckDataFetching,
    isError : isPckError  
  } = useGetPackingAnalyticsQuery(
    {
      startDate,
      endDate,
      batchFrom : makePriorLotNumber(startDate),
      batchTo : makePriorLotNumber(endDate),
    },
    {
      skip: !startDate || !endDate // avoid API call if empty
    }
  );

  const packingDayRespData = packingData?.data?.packing_day;
  const packingNightRespData = packingData?.data?.packing_night;

  return (
    <div className="po-wrapper">
      {/* PACKING DAY — orange theme */}
      <DashboardCard
        title={<><Sun size={15} color="#ee7225" style={{ marginRight: 6, flexShrink: 0 }} /> PACKING <span className="pko-shift-label">Day</span></>}
        badgeIcon={startDate && endDate ? <BatchBadge startDate={startDate} endDate={endDate} /> : null}
      >
        <div className="pko-grid-5">
          <MetricBox label="TOTAL BOXES"  value={packingDayRespData?.total_boxes_packed  ?? 0}  theme="orange" />
          <MetricBox label="CHEEKS"  value={packingDayRespData?.total_cheeks_10lb  ?? 0} unit="10 LB" theme="orange" />
          <MetricBox label="CHEEKS"  value={packingDayRespData?.total_cheeks_20lb ?? 0}  unit="20 LB" theme="orange" />
          <MetricBox label="STRIPS"  value={packingDayRespData?.total_strips_20lb ?? 0 }  unit="20 LB" theme="orange" />
          <MetricBox label="PASTING" value={packingDayRespData?.total_pasted_boxes_packed ?? 0} unit="20 LB" theme="orange" />
        </div>
      </DashboardCard>

      {/* PACKING TURN 2 — blue/purple theme */}
      <DashboardCard
        title={<><Moon size={15} color="#5b6abf" style={{ marginRight: 6, flexShrink: 0 }} /> PACKING <span className="pko-shift-label pko-shift-blue">Turn 2</span></>}
        badgeIcon={startDate && endDate ? <BatchBadge startDate={startDate} endDate={endDate} /> : null}
      >
        <div className="pko-turn2-layout">
          {/* Left: Total Boxes tall cell */}
          <div className="pko-total-cell pko-box-blue">
            <div className="pko-box-label">TOTAL BOXES<br></br>(DAY & NIGHT)</div>
            <div className="pko-box-value">{ packingDayRespData?.total_boxes_packed +  packingNightRespData?.total_night_box_packed ?? "0"}</div>
          </div>
          {/* Right: 4-col grid */}
          <div className="pko-grid-right">
            <MetricBox label="TOTAL BOXES"   value={packingNightRespData?.total_night_box_packed ?? 0}    theme="blue" />
            <MetricBox label="PRIME CHEEK BOXES"   value={packingNightRespData?.prime_cheeks_box_10lb ?? 0}   unit="10 LB" theme="blue" />
            <MetricBox label="PRIME CHEEK BOXES"   value={packingNightRespData?.prime_cheeks_box_20lb ?? 0}  unit="20 LB" theme="blue" />
            <MetricBox label="PRIME STRIP BOXES"   value={packingNightRespData?.prime_strips_box_20lb ?? 0}   unit="20 LB" theme="blue" />
            <MetricBox label="SECONDS CHEEK BOXES" value={packingNightRespData?.second_cheeks_box_20lb ?? 30} unit="20 LB" theme="blue" />
            <MetricBox label="SECONDS STRIP BOXES" value={packingNightRespData?.second_strips_box_20lb ?? 20} unit="20 LB" theme="blue" />
            <MetricBox label="TAPITAS BOXES"        value={packingNightRespData?.tapita_box_20lb ?? 100}       unit="20 LB" theme="blue" />
            <MetricBox label="PIECES BOXES"         value={packingNightRespData?.pieces_box_20lb ?? 60}        unit="20 LB" theme="blue" />
          </div>
        </div>
      </DashboardCard>

    </div>
  );
};

export default PackingOverview;
